import React, { useState } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { Form } from "react-bootstrap";
import "../../assets/css/admin.css";
import DashboardNav from "../../Components/DashboardHeader/DashboardNav";
import { Link } from "react-router-dom";
import Dropdown from "../DashboardComponents/Dropdown/Dropdown";
import DropdownDot from "../DashboardComponents/Dropdown Customer/DropdownDot";
import { AiFillCloseCircle, AiFillCheckCircle } from "react-icons/ai";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";

function EditFitting() {

    const soleDesign = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const lieAngle = [
        { value: '1', label: 'Upright', icon: '1' },
        { value: '2', label: 'Standard', icon: '2' },
        { value: '3', label: 'Flat', icon: '3' }
    ];

    const shaftWeight = [
        { value: '1', label: 'Heavy', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Light', icon: '3' }
    ];

    const shaftFlex = [
        { value: '1', label: 'Hard', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Soft', icon: '3' }
    ];

    const shaftProfile = [
        { value: '1', label: 'High', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Low', icon: '3' }
    ];

    const gripSize = [
        { value: '1', label: 'Large', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Small', icon: '3' }
    ];

    const shaftLength = [
        { value: '1', label: 'Long', icon: '1' },
        { value: '2', label: 'Medium', icon: '2' },
        { value: '3', label: 'Short', icon: '3' }
    ];

    const [notes, setNotes] = useState('');

    function goBack() {
        window.history.back()
    }

    const handleAddIron = async (event) => {
        setApicall(true);
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            setApicall(false);
        } else {
            event.preventDefault();
            const data = {
                user_id: customerId,
                filter_id: "123",
                initCustomerClub: JSON.stringify(initCustomerClub),
                initCustomerTesting: JSON.stringify(initCustomerTesting),
                notes: notes
            };

            setApicall(true);
            addIron(data).then((res) => {
                if (res.code === 200) {
                    setApicall(false);
                    // setNotes('');
                    handleShow();
                } else {
                    alert(res.data.message);
                }
            }).catch((err) => {
                alert(err);
            }
            ).finally(() => {
                setApicall(false);
            });
            setValidated(true);
        }
    };

    const [validated, setValidated] = useState(false);
    const [apicall, setApicall] = useState(false);
    const [customerId, setCustomerId] = useState('');

    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);

    const addIron = async (data) => {
        const response = await fetch("http://localhost:4000/api/addIron", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        return response.json();
    };

    const handleInitCustomerClub = (name, option) => {
        console.log("handleInitCustomerClub", name + " === " + option.value);
        setInitCustomerClub(prevState => ({
            ...prevState,
            [name]: option
        }));
    };

    const handleInitCustomerTesting = (name, option) => {
        console.log("handleInitCustomerTesting", name + " === " + option.value);
        setInitCustomerTesting(prevState => ({
            ...prevState,
            [name]: option
        }));
    };


    const [initCustomerClub, setInitCustomerClub] = useState({
        soledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        lieangle: { value: '0', label: 'Select Angle', icon: '0' },
        shaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        shaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        shaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        gripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        shaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    const [initCustomerTesting, setInitCustomerTesting] = useState({
        testingsoledesign: { value: '0', label: 'Select Bounce', icon: '0' },
        testinglieangle: { value: '0', label: 'Select Angle', icon: '0' },
        testingshaftweight: { value: '0', label: 'Select Weight', icon: '0' },
        testingshaftflex: { value: '0', label: 'Select Flex', icon: '0' },
        testingshaftprofile: { value: '0', label: 'Select Profile', icon: '0' },
        testinggripsize: { value: '0', label: 'Select SiZe', icon: '0' },
        testingshaftlength: { value: '0', label: 'Select Length', icon: '0' }
    });

    return (
        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>Customer Profile</h3>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">
                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <input type="text" className="form-control dashboard-input-box-1 me-1" placeholder="First" />
                                                            <input type="text" className="form-control dashboard-input-box-1" placeholder="Last" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Email</label>
                                                            <input type="text" className="form-control dashboard-input-box-2" placeholder="Email Address" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <input type="text" className="form-control dashboard-input-box-3" placeholder="Phone Number" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Height</label>
                                                            <div className="d-flex justify-content-end gap-2">
                                                                <input type="text" className="form-control dashboard-input-box w-30" placeholder="ft." />
                                                                <input type="text" className="form-control dashboard-input-box w-30" placeholder="in." />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Wrist to Floor</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sec-btn-group mt-4">
                                                <Link to="/fitting-view">
                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                </Link>
                                                <Link to="/fitting-view">
                                                    <button className="btn btn-save">Update Customer</button>
                                                </Link>
                                            </div>

                                            <div className='d-flex justify-content-between align-items-center'>
                                                <div className="middle-heading">
                                                    <h3>Customer Club</h3>
                                                </div>
                                            </div>

                                            <Dropdown formlable="Sole Design" options={soleDesign} name={"soledesign"} defaultSelected={initCustomerClub.soledesign} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Lie Angle" options={lieAngle} name={"lieangle"} defaultSelected={initCustomerClub.lieangle} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Weight" options={shaftWeight} name={"shaftweight"} defaultSelected={initCustomerClub.shaftweight} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Flex" options={shaftFlex} name={"shaftflex"} defaultSelected={initCustomerClub.shaftflex} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Profile" options={shaftProfile} name={"shaftprofile"} defaultSelected={initCustomerClub.shaftprofile} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Grip Size" options={gripSize} name={"gripsize"} defaultSelected={initCustomerClub.gripsize} handleDropDownChange={handleInitCustomerClub} />
                                            <Dropdown formlable="Shaft Length" options={shaftLength} name={"shaftlength"} defaultSelected={initCustomerClub.shaftlength} handleDropDownChange={handleInitCustomerClub} />

                                            <div className="middle-heading">
                                                <h3>Customer Testing</h3>
                                            </div>

                                            <DropdownDot formlable="Sole Design" options={soleDesign} name={"testingsoledesign"} defaultSelected={initCustomerTesting.testingsoledesign} handleDropDownChange={handleInitCustomerTesting} bgcolor="#ffffff" />
                                            <DropdownDot formlable="Lie Angle" options={lieAngle} name={"testinglieangle"} defaultSelected={initCustomerTesting.testinglieangle} handleDropDownChange={handleInitCustomerTesting} bgcolor="#000000" />
                                            <DropdownDot formlable="Shaft Weight" options={shaftWeight} name={"testingshaftweight"} defaultSelected={initCustomerTesting.testingshaftweight} handleDropDownChange={handleInitCustomerTesting} bgcolor="#1841EF" />
                                            <DropdownDot formlable="Shaft Flex" options={shaftFlex} name={"testingshaftflex"} defaultSelected={initCustomerTesting.testingshaftflex} handleDropDownChange={handleInitCustomerTesting} bgcolor="#E050E5" />
                                            <DropdownDot formlable="Shaft Profile" options={shaftProfile} name={"testingshaftprofile"} defaultSelected={initCustomerTesting.testingshaftprofile} handleDropDownChange={handleInitCustomerTesting} bgcolor="#8D25CD" />
                                            <DropdownDot formlable="Grip Size" options={gripSize} name={"testinggripsize"} defaultSelected={initCustomerTesting.testinggripsize} handleDropDownChange={handleInitCustomerTesting} bgcolor="#DA3026" />
                                            <DropdownDot formlable="Shaft Length" options={shaftLength} name={"testingshaftlength"} defaultSelected={initCustomerTesting.testingshaftlength} handleDropDownChange={handleInitCustomerTesting} bgcolor="#D78A31" />


                                            <div className="middle-heading">
                                                <h3>Club Comparison</h3>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Sole Design
                                                        </div>
                                                        <div className="right-icon worang">
                                                            <AiFillCloseCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.soledesign.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingsoledesign.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Lie Angle
                                                        </div>
                                                        <div className="right-icon right">
                                                            <AiFillCheckCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.lieangle.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testinglieangle.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Weight
                                                        </div>
                                                        <div className="right-icon">
                                                            <AiFillCloseCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.shaftweight.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingshaftweight.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Flex
                                                        </div>
                                                        <div className="right-icon right">
                                                            <AiFillCheckCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.shaftflex.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingshaftflex.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Profile
                                                        </div>
                                                        <div className="right-icon">
                                                            <AiFillCloseCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.shaftprofile.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingshaftprofile.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Grip Size
                                                        </div>
                                                        <div className="right-icon right">
                                                            <AiFillCheckCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.gripsize.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testinggripsize.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <div className="form-box-inner">
                                                    <div className="compare-club-header">
                                                        <div className="dashboard-form-lable">
                                                            Shaft Length
                                                        </div>
                                                        <div className="right-icon right">
                                                            <AiFillCheckCircle />
                                                        </div>
                                                    </div>

                                                    <div className="form-btn-group">
                                                        <div className="btn-alert">{initCustomerClub.shaftlength.label}</div>
                                                        <div className="btn-susses">{initCustomerTesting.testingshaftlength.label}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="middle-heading">
                                                <h3>Fitter Notes</h3>
                                            </div>

                                            <div className="form-box-section mb-3">
                                                <textarea className="dashboard-text-area" id="exampleFormControlTextarea1" rows="8" value={notes} placeholder="Leave your note here..." onChange={(e) => setNotes(e.target.value)}></textarea>
                                            </div>

                                            <div className="sec-btn-group mt-4">
                                                <Link to="/fitting">
                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                </Link>
                                                <Link to="/fitting">
                                                    <button className="btn btn-save">Save new customer</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default EditFitting;